<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <div class="wow-form-header">
                    <div class="wow-form-header__icon"><mat-icon>attach_money</mat-icon></div>
                    <mat-card-title>
                        Contas à Receber
                        <span class="cf-form-id" *ngIf="formulario.value.id"> — ID {{ formulario.value.id }}</span>
                    </mat-card-title>
                </div>
                <form [formGroup]="formulario" (ngSubmit)="submit()">
                    <app-conta-financeira-cadastro
                        [formulario]="formulario"
                        [baixaForm]="baixaForm"
                        [myControl]="myControl"
                        [pagadoresLista]="pagadoresLista"
                        [bloquearCampoEdicao]="bloquearCampoEdicao"
                        [config]="config"
                        [valorPago]="valorPago"
                        [valorRestante]="valorRestante"
                        [statusPagamento]="statusPagamento"
                        [baixas]="baixas"
                        [contaAberta]="contaAberta()"
                        [possuiAnexoFatura]="possuiAnexoFatura"
                        [possuiAnexoBaixa]="possuiAnexoBaixa"
                        [nomeArquivoFaturaSelecionado]="nomeArquivoFaturaSelecionado"
                        [nomeArquivoBaixaSelecionado]="nomeArquivoBaixaSelecionado"
                        [nomeArquivoFaturaSalvo]="nomeArquivoFaturaSalvo"
                        [temContaSalva]="!!formulario.value.id"
                        [contasCorrentes]="contasCorrentes"
                        [segmentos]="segmentos"
                        (calcularTotal)="calcularValorTotal()"
                        (listarPagador)="listarPagador()"
                        (selecionarFatura)="onArquivoFatura($event)"
                        (selecionarComprovante)="onArquivoBaixa($event)"
                        (anexarFatura)="anexarFaturaConta()"
                        (registrarBaixa)="registrarBaixa()"
                        (baixarAnexo)="baixarAnexo($event)"
                        (copiarPix)="copiarPix($event)"
                        (baixarBolepix)="baixarBolepix()"
                        (baixarComprovantePix)="baixarComprovantePix()">
                    </app-conta-financeira-cadastro>
                    <div class="cr-encargo-atraso" *ngIf="possuiEncargoAtraso">
                        <mat-icon>warning_amber</mat-icon>
                        <span>
                            Conta vencida há <strong>{{ diasAtraso }}</strong> {{ diasAtraso === 1 ? 'dia' : 'dias' }} —
                            juros e multa já aplicados nos campos acima.
                            <em>(estimativa diária — o valor final é o liquidado pelo banco)</em>
                        </span>
                    </div>
                    <div class="cr-auditoria-valor" *ngIf="valorAlteradoPor">
                        <mat-icon>history</mat-icon>
                        Valor alterado por <strong>{{ valorAlteradoPor }}</strong>
                        <span *ngIf="valorAlteradoEm"> em {{ valorAlteradoEm }}</span>.
                    </div>
                    <div class="wow-form-acoes">
                        <button type="button" mat-stroked-button (click)="voltarConsulta()">
                            <mat-icon>arrow_back</mat-icon> Voltar
                        </button>
                        <button [disabled]="!formulario.valid || myControl.invalid" mat-raised-button color="primary" type="submit">
                            <mat-icon>save</mat-icon> Salvar
                        </button>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
</main>

<ng-template #dialogRegerar>
    <h2 mat-dialog-title>Alterar valor da cobrança</h2>
    <mat-dialog-content>
        <p>
            Esta conta já possui uma cobrança gerada (QR Code / boleto) e o valor foi alterado.
        </p>
        <p>
            Deseja realmente alterar e <strong>regerar o QR Code / boleto</strong> com o novo valor?
            A alteração ficará registrada (quem alterou e quando).
        </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-stroked-button [mat-dialog-close]="false">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">
            <mat-icon>autorenew</mat-icon> Alterar e regerar
        </button>
    </mat-dialog-actions>
</ng-template>
